import _ from 'lodash';
export const name = 'SINGLE_LINK.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            <span title={cellValue} data-link-type={prop} data-link-data={cellValue} data-patent-id={PATENT_ID} data-patent-no={PN}>
                {cellValue}
            </span>
        </div>,
    ];
}
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
